import { render, staticRenderFns } from "./BasePrefixInput.vue?vue&type=template&id=9f26c100"
import script from "./BasePrefixInput.vue?vue&type=script&lang=js"
export * from "./BasePrefixInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f26c100')) {
      api.createRecord('9f26c100', component.options)
    } else {
      api.reload('9f26c100', component.options)
    }
    module.hot.accept("./BasePrefixInput.vue?vue&type=template&id=9f26c100", function () {
      api.rerender('9f26c100', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/BasePrefixInput.vue"
export default component.exports